import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-opd',
  templateUrl: './opd.component.html',
  styleUrls: []
})
export class OpdComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/opd/opd.component.ts